export * from './header-menu.component';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/header-menu/index.ts